import useSettingForm from '../form/useSettingForm';
import { useStudentContext } from '../../../context/MyStudentContextProvider';
import { useDomain } from '../../../../../states/AppDomainProvider';
import MaxChoices from '../../../../settings/interaction/MaxChoices';

const MaxChoicesSettings = () => {
  const { updateProfileSettingsOnChange } = useSettingForm('Max Choices');
  const { studentsDomain } = useDomain();
  const { currentSelectedStudentId } = studentsDomain.domainData;
  const { myStudentDomain } = useStudentContext();
  const { selectedStudentProfile } = myStudentDomain.domainData;

  const onChange = (newValue) => {
    updateProfileSettingsOnChange(currentSelectedStudentId, {
      maxMatchingChoices: newValue,
    });
  };

  return (
    <MaxChoices
      profile={selectedStudentProfile}
      onChangeCallback={(newValue) => onChange(newValue)}
    />
  );
};

export default MaxChoicesSettings;
